import React, { FC, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AOS from 'aos'
import dynamic from 'next/dynamic'
// import Testimonials from 'components/HomePage/Testimonials'
import ContactUsDarkSection from 'components/ContactUsPage/ContactUsDarkSection'
import Link from 'next/link'
import Slider from 'react-slick'
import Image from 'next/image'
// import imageClient1 from '../../../public/assets/images/our-client-img-1.png'
// import imageClient2 from '../../../public/assets/images/our-client-img-2.png'
// import imageClient3 from '../../../public/assets/images/our-client-img-3.png'
// import imageClient4 from '../../../public/assets/images/our-client-img-4.png'
// import imageClient5 from '../../../public/assets/images/Peugeot-logo.png'
// import imageClient6 from '../../../public/assets/images/our-client-img-t.png'
// import imageClient7 from '../../../public/assets/images/alo-yoga-logo-vector.png'
// import imageClient8 from '../../../public/assets/images/duba-traspernti.png'
// import imageClient9 from '../../../public/assets/images/screen.png'
// import imageClient10 from '../../../public/assets/images/VBit-Mining-logo.png'
// import imageClient11 from '../../../public/assets/images/tawuniya-vector-logo.png'
// import imageClient12 from '../../../public/assets/images/sky.png'

const imageClient1 = '/assets/images/our-client-img-1.png'
const imageClient2 = '/assets/images/our-client-img-2.png'
const imageClient3 = '/assets/images/our-client-img-3.png'
const imageClient4 = '/assets/images/our-client-img-4.png'
const imageClient5 = '/assets/images/Peugeot-logo.png'
const imageClient6 = '/assets/images/our-client-img-t.png'
const imageClient7 = '/assets/images/alo-yoga-logo-vector.png'
const imageClient8 = '/assets/images/duba-traspernti.png'
const imageClient9 = '/assets/images/screen.png'
const imageClient10 = '/assets/images/VBit-Mining-logo.png'
const imageClient11 = '/assets/images/tawuniya-vector-logo.png'
const imageClient12 = '/assets/images/sky.png'

const ContactInformation = dynamic(
  () => import('components/HomePage/ContactInformation'),
  {
    ssr: false,
  }
)
const Testimonials = dynamic(() => import('components/HomePage/Testimonials'), {
  ssr: false,
})

export async function getStaticProps() {
  return { props: { isErrorCls: true } }
}

const accoladesSettings = {
  dots: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000,
}

const ContactusPage: FC = () => {
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <div>
      <section className="contact-us-main pt-120px pb-120px d-flex flex-column justify-content-center ">
        <Container>
          <Row className="pt-5 align-items-center">
            <Col xl={6}>
              <div className="darks_bg form_block form-padd mb-4 mb-xl-0 dark_form">
                <ContactUsDarkSection />
              </div>
            </Col>
            <Col xl={6}>
              <div className="social-contact">
                <Row className="align-items-stretch">
                  <Col lg={6} className="mb-4">
                    <Link
                      href="skype:webcluesinfotech?chat"
                      target="_blank"
                      className="social-contact-item"
                    >
                      <div className="dark_blue_bg rounded-xl d-flex align-items-center px-3 px-sm-4 py-3 py-sm-4">
                        <div className="social-contact-icon">
                          <Image
                            src="/assets/images/Skype.svg"
                            alt="Skype"
                            width={34}
                            height={34}
                            style={{
                              maxWidth: '100%',
                              height: 'auto',
                            }}
                          />
                        </div>
                        <div className="social-contact-inner">
                          <small className="text-white fw-400 text_para opacity6">
                            Skype
                          </small>
                          <p className="text-white fw-400 fs-18px fs-md-19px mb-0 pt-2">
                            webcluesinfotech
                          </p>
                        </div>
                      </div>
                    </Link>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <Link
                      href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;tf=1&amp;to=sales@webcluesinfotech.com"
                      target="_blank"
                      className="social-contact-item"
                    >
                      <div className="dark_blue_bg rounded-xl d-flex align-items-center px-3 px-sm-4 py-3 py-sm-4">
                        <div className="social-contact-icon">
                          <Image
                            src="/assets/images/Email.svg"
                            alt="Email"
                            width={34}
                            height={34}
                            style={{
                              maxWidth: '100%',
                              height: 'auto',
                            }}
                          />
                        </div>
                        <div className="social-contact-inner">
                          <small className="text-white fw-400 text_para opacity6">
                            Email
                          </small>
                          <p className="text-white fw-400 fs-18px fs-md-19px mb-0 pt-2">
                            sales@webcluesinfotech.com
                          </p>
                        </div>
                      </div>
                    </Link>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <a
                      href="tel: +971-50-257-8857"
                      className="social-contact-item"
                    >
                      <div className="dark_blue_bg rounded-xl d-flex align-items-center px-3 px-sm-4 py-3 py-sm-4">
                        <div className="social-contact-icon">
                          <Image
                            src="/assets/images/USA.svg"
                            alt="USA"
                            width={34}
                            height={34}
                            style={{
                              maxWidth: '100%',
                              height: 'auto',
                            }}
                          />
                        </div>
                        <div className="social-contact-inner">
                          <small className="text-white fw-400 text_para opacity6">
                            UAE
                          </small>
                          <p className="text-white fw-400 fs-18px fs-md-19px mb-0 pt-2">
                            +971-50-257-8857
                          </p>
                        </div>
                      </div>
                    </a>
                  </Col>
                  {/* <Col lg={6} className="mb-4">
                    <a href="tel:+16317100488" className="social-contact-item">
                      <div className="dark_blue_bg rounded-xl d-flex align-items-center px-3 px-sm-4 py-3 py-sm-4">
                        <div className="social-contact-icon">
                          <img
                            src="/assets/images/USA.svg"
                            alt="USA"
                            width={75}
                            height={75}
                          />
                        </div>
                        <div className="social-contact-inner">
                          <small className="text-white fw-400 text_para opacity6">
                            USA
                          </small>
                          <p className="text-white fw-400 fs-18px fs-md-19px mb-0 pt-2">
                            +1-(631)-710-0488
                          </p>
                        </div>
                      </div>
                    </a>
                  </Col> */}
                  <Col lg={6} className="mb-4">
                    <a href="tel:+918141068282" className="social-contact-item">
                      <div className="dark_blue_bg rounded-xl d-flex align-items-center px-3 px-sm-4 py-3 py-sm-4">
                        <div className="social-contact-icon">
                          <Image
                            src="/assets/images/India.svg"
                            alt="India"
                            width={34}
                            height={34}
                            style={{
                              maxWidth: '100%',
                              height: 'auto',
                            }}
                          />
                        </div>
                        <div className="social-contact-inner">
                          <small className="text-white fw-400 text_para opacity6">
                            India
                          </small>
                          <p className="text-white fw-400 fs-18px fs-md-19px mb-0 pt-2">
                            +91- 814-106-8282
                          </p>
                        </div>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>

              <div className="lg-logo-main accolades_mentions">
                <div className="title_sm text_black pb-4">
                  Accolades and Mentions
                </div>
                {/* <Slider
                  className="contact_client_slider"
                  {...accoladesSettings}
                >
                  <div> */}

                <Row>
                  <Col md={3} className="mb-lg-3">
                    <div className="accolades_mentions_item text-center text-decoration-none">
                      <div className="am_badge">
                        <Image
                          src="/assets/images/cmmi-logo-black.svg"
                          className="mx-auto"
                          alt="CMMI-Level-5"
                          width={133}
                          height={100}
                        />
                      </div>
                      <div className="am_text mt-2">
                        <span className="">CMMI Level 5</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="mb-lg-3">
                    <Link
                      href="https://clutch.co/profile/webclues-infotech"
                      target="_blank"
                      className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                    >
                      <div className="am_badge">
                        <Image
                          src="/assets/images/am-badge-img1.png"
                          className="mx-auto"
                          alt="Clutch"
                          width={112}
                          height={100}
                        />
                      </div>
                      <div className="am_text mt-2">
                        <span className="">Clutch</span>
                      </div>
                    </Link>
                  </Col>
                  <Col md={3} className="mb-lg-3">
                    <Link
                      href="https://www.goodfirms.co/company/webclues-infotech"
                      target="_blank"
                      className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                    >
                      <div className="am_badge">
                        <Image
                          src="/assets/images/am-badge-img2.png"
                          className="mx-auto"
                          alt="GoodFirms"
                          width={128}
                          height={100}
                        />
                      </div>
                      <div className="am_text mt-2">
                        <span className="">GoodFirms</span>
                      </div>
                    </Link>
                  </Col>
                  <Col md={3} className="mb-lg-3">
                    <Link
                      href="https://www.appfutura.com/developers/webcluesinfotech"
                      target="_blank"
                      className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                    >
                      <div className="am_badge">
                        <Image
                          src="/assets/images/am-badge-img3.png"
                          className="mx-auto"
                          alt="AppFutura"
                          width={123}
                          height={100}
                        />
                      </div>
                      <div className="am_text mt-2">
                        <span className="">AppFutura</span>
                      </div>
                    </Link>
                  </Col>
                </Row>
                {/* </div> */}
                {/* <div>
                    <Row>
                      <Col xs={6} className="mb-3">
                        <Link href="https://www.topdevelopers.co/directory/mobile-app-development-companies-in-usa">
                          <a
                            target="_blank"
                            className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                          >
                            <div className="am_badge">
                              <img
                                src="/assets/images/am-badge-img4.png"
                                className="mx-auto"
                                alt="img"
                              />
                            </div>
                            <div className="am_text mt-4">
                              <span className="">TopDevelopers</span>
                            </div>
                          </a>
                        </Link>
                      </Col>
                      <Col xs={6} className="mb-3">
                        <Link href="https://www.softwareworld.co/top-mobile-app-development-companies-in-usa/">
                          <a
                            target="_blank"
                            className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                          >
                            <div className="am_badge">
                              <img
                                src="/assets/images/am-badge-img5.png"
                                className="mx-auto"
                                alt="img"
                              />
                            </div>
                            <div className="am_text mt-4">
                              <span className="">SoftwareWorld</span>
                            </div>
                          </a>
                        </Link>
                      </Col>
                      <Col xs={6} className="mb-3">
                        <Link href="https://www.mobileappdaily.com/mobile-app-development/blockchain/companies/amp">
                          <a
                            target="_blank"
                            className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                          >
                            <div className="am_badge">
                              <img
                                src="/assets/images/am-badge-img6.png"
                                className="mx-auto"
                                alt="img"
                              />
                            </div>
                            <div className="am_text mt-4">
                              <span className="">MobileAppDaily</span>
                            </div>
                          </a>
                        </Link>
                      </Col>
                      <Col xs={6} className="mb-3">
                        <Link href="https://www.trustfirms.com/top-android-ios-mobile-app-developers-companies/">
                          <a
                            target="_blank"
                            className="accolades_mentions_item text-center text-decoration-none cursorArrowArea"
                          >
                            <div className="am_badge">
                              <img
                                src="/assets/images/am-badge-img7.png"
                                className="mx-auto"
                                alt="img"
                              />
                            </div>
                            <div className="am_text mt-4">
                              <span className="">TrustFirms</span>
                            </div>
                          </a>
                        </Link>
                      </Col>
                    </Row>
                  </div> */}
                {/* </Slider> */}
                {/* <Row className="text-center">
                  <Col sm={6} lg={6} xl={6} className="mb-5">
                    <Link href="https://clutch.co/profile/webclues-infotech">
                      <a
                        target="_blank"
                        className="accolades_mentions_item text-center text-decoration-none"
                      >
                        <div className="am_badge">
                          <img
                            src="/assets/images/am-badge-img1.png"
                            alt="benefits1"
                          />
                        </div>
                        <div className="am_text mt-4">
                          <span>Clutch</span>
                        </div>
                      </a>
                    </Link>
                  </Col>
                  <Col sm={6} lg={6} xl={6} className="mb-5">
                    <Link href="https://www.goodfirms.co/company/webclues-infotech">
                      <a
                        target="_blank"
                        className="accolades_mentions_item text-center text-decoration-none"
                      >
                        <div className="am_badge">
                          <img
                            src="/assets/images/am-badge-img2.png"
                            alt="benefits1"
                          />
                        </div>
                        <div className="am_text mt-4">
                          <span>GoodFirms</span>
                        </div>
                      </a>
                    </Link>
                  </Col>
                  <Col sm={6} lg={6} xl={6} className="mb-5">
                    <Link href="https://www.appfutura.com/developers/webcluesinfotech">
                      <a
                        target="_blank"
                        className="accolades_mentions_item text-center text-decoration-none"
                      >
                        <div className="am_badge">
                          <img
                            src="/assets/images/am-badge-img3.png"
                            alt="benefits1"
                          />
                        </div>
                        <div className="am_text mt-4">
                          <span>AppFutura</span>
                        </div>
                      </a>
                    </Link>
                  </Col>
                  <Col sm={6} lg={6} xl={6} className="mb-5">
                    <Link href="https://www.topdevelopers.co/directory/mobile-app-development-companies-in-usa">
                      <a
                        target="_blank"
                        className="accolades_mentions_item text-center text-decoration-none"
                      >
                        <div className="am_badge">
                          <img
                            src="/assets/images/am-badge-img4.png"
                            alt="benefits1"
                          />
                        </div>
                        <div className="am_text mt-4">
                          <span>Top Developers</span>
                        </div>
                      </a>
                    </Link>
                  </Col>
                </Row> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="trusted-by-sec">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="title_md mb-4 text_black">Trusted By</h2>
                <p className="text_para mb-5">
                  National and Multinational companies trust WebClues to create
                  unique and novel digital experiences for their customers and
                  clients. Our creative thinking is bolstered by strategic
                  analysis and progressive technologies, enabling our clients to
                  cruise through the tough competition toward success.
                </p>
              </div>
            </Col>
          </Row>
          <div className="trusted-by-imgs">
            <div className="linegrey_1" />
            <div className="linegrey_2" />
            <Row>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient1}`}
                    alt="our-client-img-1"
                    width={216}
                    height={39}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient2}`}
                    alt="our-client-img-2"
                    width={196}
                    height={50}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient3}`}
                    alt="our-client-img-3"
                    width={81}
                    height={121}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient4}`}
                    alt="our-client-img-4"
                    width={212}
                    height={69}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="cnt_row">
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient5}`}
                    alt="benefits1"
                    width={140}
                    height={94}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className=" tem_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient6}`}
                    alt="benefits1"
                    width={146}
                    height={58}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className=" tem_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient7}`}
                    alt="benefits1"
                    width={101}
                    height={68}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient8}`}
                    alt="benefits1"
                    width={113}
                    height={57}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="cnt_row">
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient9}`}
                    alt="benefits1"
                    width={200}
                    height={60}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className=" tem_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient10}`}
                    alt="benefits1"
                    width={200}
                    height={25}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className=" tem_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient11}`}
                    alt="benefits1"
                    width={166}
                    height={62}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={6}
                xs={6}
                lg={3}
                className="trust-img-border-right mb-4 mb-lg-0"
              >
                <div className="item_img d-flex justify-content-center align-items-center mx-auto">
                  <Image
                    src={`${imageClient12}`}
                    alt="benefits1"
                    width={200}
                    height={60}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <Testimonials
        data={{
          title: 'Our customers love what we do',
          text: [
            'Our success is directly proportional to our client’s satisfaction. With an overall experience of more than a decade in this domain, we have built a strong trust and global client base by providing quality services.',
            'Our clients trust us as the top notch Web and Mobile App Development Company. Hear it straight from our clients.',
          ],
        }}
      />
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
    </div>
  )
}

export default ContactusPage
